import React from 'react';
import { maskPhoneBR, normalizePhoneBR } from '../utils/phone';

/**
 * PhoneInput — input controlado que aplica mascara BR em tempo de digitacao.
 *
 * Uso:
 *   <PhoneInput
 *     value={form.phone}
 *     onChange={(masked, normalized) => setForm(f => ({ ...f, phone: normalized }))}
 *     placeholder="(11) 91234-5678"
 *     required
 *   />
 *
 * - `value` pode ser qualquer formato (com ou sem mascara, com ou sem 55) —
 *   o componente exibe mascarado.
 * - `onChange(maskedValue, normalizedValue)` e chamado com DOIS argumentos:
 *     - maskedValue: o que o usuario ve ("(11) 91234-5678")
 *     - normalizedValue: pronto pro backend ("5511912345678") ou null se invalido
 *   Assim o parent pode escolher guardar a versao normalizada direto no state
 *   (recomendado) ou a mascarada (legado).
 *
 * - Usa inputMode="tel" e pattern que favorecem teclado numerico em mobile.
 * - Limita digitos maximos a 11 (movel com DDD) — o componente ignora
 *   entrada alem disso.
 */
export default function PhoneInput({
  value,
  onChange,
  placeholder = '(11) 91234-5678',
  required = false,
  disabled = false,
  className = 'input',
  id,
  name = 'phone',
  style,
  ...rest
}) {
  const displayValue = maskPhoneBR(value || '');

  const handleChange = (e) => {
    const raw = e.target.value;
    const masked = maskPhoneBR(raw);
    const normalized = normalizePhoneBR(raw);
    if (onChange) onChange(masked, normalized);
  };

  return (
    <input
      type="tel"
      inputMode="tel"
      autoComplete="tel-national"
      id={id}
      name={name}
      className={className}
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      maxLength={16}
      style={style}
      {...rest}
    />
  );
}
